@if (selection?.station != null) {
  <sc-flex vertical stretchContent fitHeight class="station-details">
    <div class="tab-group">
      <sc-flex>
        @if (selection.station.stationUsage.transports?.length !== 0) {
          <div class="tab" [ngClass]="{'selected' : selectedTab === 'details'}" (click)="selectTab('details')">
            <sc-flex>
              <sc-icon iconClass="fa-truck"></sc-icon>
              @if (selectedTab === 'details') {
                <sc-content-spacer [half]="true"></sc-content-spacer>
                Details
              }
            </sc-flex>
          </div>
          <div class="tab" [ngClass]="{'selected' : selectedTab === 'tasks'}" (click)="selectTab('tasks')">
            <sc-flex>
              <sc-icon iconClass="fa-list-check"></sc-icon>
              @if (selectedTab === 'tasks') {
                <sc-content-spacer [half]="true"></sc-content-spacer>
                Aufgaben
              }
            </sc-flex>
          </div>
          <div class="tab" [ngClass]="{'selected' : selectedTab === 'actions'}" (click)="selectTab('actions')">
            <sc-flex>
              <sc-icon iconClass="fa-gears"></sc-icon>
              @if (selectedTab === 'actions') {
                <sc-content-spacer [half]="true"></sc-content-spacer>
                Aktionen
              }
            </sc-flex>
          </div>
          <div class="tab" [ngClass]="{'selected' : selectedTab === 'documents'}"
            (click)="selectTab('documents')">
            <sc-flex>
              <sc-icon iconClass="fa-file"></sc-icon>
              @if (selectedTab === 'documents') {
                <sc-content-spacer [half]="true"></sc-content-spacer>
                Dokumente
              }
            </sc-flex>
          </div>
        }
        @if (selection.station.stationUsage.transports?.length === 0) {
          <div class="tab">
            <sc-flex>
              <sc-icon iconClass="fa-truck"></sc-icon>
              <sc-content-spacer [half]="true"></sc-content-spacer>
              verfügbare Transporte
            </sc-flex>
          </div>
        }
      </sc-flex>
    </div>
    <sc-flex-fitting-content vertical>
      @if (selection.station.stationUsage.transports?.length !== 0 && selectedTab==='details') {
        <app-sac-mobile-transport-details [station]="selection.station"
        ></app-sac-mobile-transport-details>
      }
      @if (selection.station.stationUsage.transports?.length !== 0 && selectedTab==='tasks') {
        <app-task-position-details [transportId]="selection.station.stationUsage.transports[0].id"
        ></app-task-position-details>
      }
      @if (selection.station.stationUsage.transports?.length !== 0 && selectedTab==='actions') {
        <app-sac-mobile-transport-actions [station]="selection.station" [stationSet]="selection.stationSet"
        ></app-sac-mobile-transport-actions>
      }
      @if (selection.station.stationUsage.transports?.length !== 0 && selectedTab==='documents') {
        <app-sac-mobile-transport-documents [station]="selection.station"
        ></app-sac-mobile-transport-documents>
      }
      @if (selection.station.stationUsage.transports?.length === 0) {
        <sc-padding fitHeight>
          <app-sac-transports [selection]="selection">
          </app-sac-transports>
        </sc-padding>
      }
    </sc-flex-fitting-content>
  </sc-flex>
}
